
import { Inject, Injectable, DOCUMENT } from '@angular/core';

@Injectable()
export class LanguageService {

  constructor(@Inject(DOCUMENT) private document: Document) { }

  textDirection(lang: string) {
    if (lang === 'ara')
      this.document.documentElement.dir = 'rtl';
    else
      this.document.documentElement.dir = 'ltr';
  }
}
